
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tables } from "@/integrations/supabase/types";
import QuoteForm from "./QuoteForm";

type Quote = Tables<'quotes'>;

interface QuoteFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  bookingId: string;
  mode: 'new' | 'revise' | 'variation';
  parentQuote?: Quote;
  onQuoteAdded: () => void;
  existingQuotesCount?: number;
}

const QuoteFormModal: React.FC<QuoteFormModalProps> = ({
  isOpen,
  onClose,
  bookingId,
  mode,
  parentQuote,
  onQuoteAdded,
  existingQuotesCount = 0
}) => {
  const getTitle = () => {
    switch (mode) {
      case 'revise':
        return `Revise Quote #${parentQuote?.id.slice(-8)}`;
      case 'variation':
        return `Add Variation to Quote #${parentQuote?.id.slice(-8)}`;
      default:
        return 'Add New Quote';
    }
  };

  const getDefaultValues = () => {
    if (!parentQuote) return undefined;

    return {
      quoteType: mode === 'revise' ? 'revised' : mode === 'variation' ? 'variation' : 'initial',
      parentQuoteId: parentQuote.id,
      quotedAmount: mode === 'revise' ? parentQuote.quoted_amount?.toString() || '' : '',
      variationReason: mode === 'variation' ? '' : undefined,
    } as const;
  };

  const handleQuoteAdded = () => {
    onQuoteAdded();
    onClose();
  };

  const isFirstQuote = existingQuotesCount === 0 && mode === 'new';

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{getTitle()}</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <QuoteForm
            bookingId={bookingId}
            onQuoteAdded={handleQuoteAdded}
            isAdmin={true}
            isFirstQuote={isFirstQuote}
            defaultValues={getDefaultValues()}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QuoteFormModal;
